@if (hasValidAuthor) {
  <span class="author-view-wrapper">
    <!-- Link Display Mode -->
    @if (display === 'link') {
      <a
        class="citation_author from-journal"
        href="javascript:void(0)"
        (click)="onAuthorClicked($event)"
        [title]="'author.clickForDetails' | translate">
        {{ author.fullName }}
      </a>
    }
    <!-- Inline Display Mode -->
    @if (display === 'inline') {
      <span class="author-inline">
        <!-- Author Title -->
        @if (author.showTitle && author.title && author.title !== 'Yok') {
          <span class="author-title">
            {{ author.title | translate }}
          </span>
        }
        <!-- Author Name (clickable) -->
        <a
          class="citation_author from-journal"
          href="javascript:void(0)"
          (click)="onAuthorClicked($event)"
          [title]="'author.clickForDetails' | translate">
          {{ author.fullName }}
        </a>
        <!-- Separator -->
        <span class="author-separator">, </span>
        <!-- Author Affiliation -->
        <span class="author-affiliation">{{ getAuthorAffiliation() }}</span>
      </span>
    }
    <!-- Popover -->
    @if (popover) {
      <div
        #popoverRef
        class="author-detail"
        [class.right-placed]="rightPlaced"
        [class.left-placed]="!rightPlaced"
        [ngStyle]="getPopoverStyle()">
        <div class="popover-content">
          <!-- Author Header -->
          <div class="author-header d-flex align-items-center justify-content-between">
            <h4 class="mt-1 mb-1">
              <strong>
                @if (author.title && author.title !== 'Yok') {
                  <span>{{ author.title | translate }} </span>
                }
                <span>{{ author.fullName }} </span>
              </strong>
            </h4>
            <!-- <button
            type="button"
            class="btn-close p-1 ms-2"
            (click)="closePopover()"
            [attr.aria-label]="'close' | translate">
            <i class="fas fa-times"></i>
          </button> -->
        </div>
        <hr class="solid my-2">
        <!-- Author Details -->
        <ul class="list list-icons list-icons-style-1 mt-2 mb-0">
          <!-- Location/Institution -->
          @if (getAuthorLocation()) {
            <li class="mb-2">
              <i class="fas fa-map-marker-alt top-6 from-journal me-2"></i>
              <span>{{ getAuthorLocation() }}</span>
            </li>
          }
          <!-- Email -->
          @if (author.email) {
            <li class="mb-2">
              <i class="fas fa-envelope top-6 from-journal me-2"></i>
              <a
                class="from-journal email-link"
                href="javascript:void(0)"
                (click)="openEmail()">
                {{ author.email }}
              </a>
            </li>
          }
          <!-- Profile Link -->
          @if (author.slug) {
            <li class="mb-2">
              <i class="fas fa-user top-6 from-journal me-2"></i>
              <a
                href="javascript:void(0)"
                (click)="navigateToAuthor()">
                {{ author.slug }}
              </a>
            </li>
          }
          <!-- ORCID -->
          @if (author.orcid) {
            <li class="mb-2">
              <i class="fab fa-orcid top-6 from-journal me-2"></i>
              <a
                href="javascript:void(0)"
                class="orcid-link"
                (click)="openOrcid()"
                [title]="'author.orcidProfile' | translate">
                {{ getOrcidDisplay() }}
              </a>
            </li>
          }
          <!-- Website -->
          @if (author.website) {
            <li class="mb-2">
              <i class="fas fa-globe top-6 from-journal me-2"></i>
              <a
                href="javascript:void(0)"
                class="website-link"
                (click)="openWebsite()"
                [title]="'author.website' | translate">
                {{ 'author.personalWebsite' | translate }}
              </a>
            </li>
          }
          <!-- Department (if different from institution) -->
          @if (author.department && author.department !== author.institution) {
            <li class="mb-2">
              <i class="fas fa-building top-6 from-journal me-2"></i>
              <span>{{ author.department }}</span>
            </li>
          }
        </ul>
        <!-- No additional info message -->
        @if (!hasContactInfo() && !getAuthorLocation()) {
          <div class="no-info">
            <p class="text-muted mb-0">{{ 'author.noAdditionalInfo' | translate }}</p>
          </div>
        }
      </div>
    </div>
  }
</span>
}
